import { getProspectReference } from "@utils/storage";
import { getEndpoint } from "./endpoint";

const MS_NAME = "cross-sell";

export const updateTermsAndConditionRouteCrossSell = () =>
    `${getEndpoint(MS_NAME)}${getProspectReference()}/carts/terms-and-conditions`;
